import { Helpers } from '../../helpers';
import { ICostTypeCategory } from '../../interfaces/icost-type-category';
import { CostType } from '../cost-type';

export class CostTypeCategoryBase {
  CostTypeCategoryId: number;
  CostTypeCategoryDescription: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CostTypes_CostTypeCategory?: Array<CostType> | null;

  constructor(item?: ICostTypeCategory) {
    if (item) {

      this.CostTypeCategoryId = item.CostTypeCategoryId;
      this.CostTypeCategoryDescription = item.CostTypeCategoryDescription;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CostTypes_CostTypeCategory = Helpers.createClassArray(CostType, item.CostTypes_CostTypeCategory);
    }
  }
}